"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCountrySelector = void 0;
var react_1 = require("react");
var useCountrySelector = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.enableCountryChange, enableCountryChange = _c === void 0 ? true : _c, _d = _b.disabled, disabled = _d === void 0 ? false : _d;
    var _e = (0, react_1.useState)(false), isCountryMenuOpen = _e[0], setIsCountryMenuOpen = _e[1];
    var openCountryMenu = (0, react_1.useCallback)(function () {
        if (enableCountryChange && !disabled) {
            setIsCountryMenuOpen(true);
        }
    }, [enableCountryChange, disabled]);
    var closeCountryMenu = (0, react_1.useCallback)(function () {
        setIsCountryMenuOpen(false);
    }, []);
    var handleCountrySelectClick = (0, react_1.useCallback)(function () {
        openCountryMenu();
    }, [openCountryMenu]);
    var handleKeyDown = (0, react_1.useCallback)(function (e) {
        if (enableCountryChange &&
            !disabled &&
            (e.key === 'Enter' || e.key === ' ')) {
            e.preventDefault();
            openCountryMenu();
        }
    }, [enableCountryChange, disabled, openCountryMenu]);
    return {
        isCountryMenuOpen: isCountryMenuOpen,
        openCountryMenu: openCountryMenu,
        closeCountryMenu: closeCountryMenu,
        handleCountrySelectClick: handleCountrySelectClick,
        handleKeyDown: handleKeyDown,
    };
};
exports.useCountrySelector = useCountrySelector;
//# sourceMappingURL=useCountrySelector.js.map